import styled from 'styled-components'

import { untilMd } from '@syconium/little-miss-figgy'

export const MobileViewItem = styled.div<{
  background: string
}>`
  background: ${o => o.background};
`

export const MobileViewWrapper = styled.div`
  display: none;

  ${untilMd} {
    display: initial;
  }
`

export const BottomDownloadSection = styled.div`
  padding: 40px 10px;
  background: #282828;
`

export const BottomDownloadTitle = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 48px;
  text-align: center;
  letter-spacing: 5.4px;
  text-transform: uppercase;
  color: #ffffff;
`
